import { IsString, IsNotEmpty } from 'class-validator';
import { SiteSettings } from './site-settings-types';

// Access request document from MongoDB
export interface AccessRequest {
  id: string;
  analystId: number;
  siteId: string;
  requestedAt: string;
  status: 'Pending' | 'Approved' | 'Dismissed';
  analystEmail: string;
  analystName: string;
  firmName?: string;
}

// DTO for submitting request
export class AccessRequestSubmissionDTO {
  @IsString()
  @IsNotEmpty()
  siteId!: string;
}

// Response from submission
export interface AccessRequestResponseDTO {
  success: boolean;
  message: string;
  canRequestAgain?: boolean;
  nextRequestAvailableAt?: string;
}

// Rate limit check response
export interface AccessRequestRateLimitStatus {
  canRequest: boolean;
  lastRequestDate?: string;
  nextAvailableDate?: string; // ISO date when they can request again (30 days after last request)
  daysRemaining?: number; // Days until they can request again
}

// Vendor connection status enum
export enum VendorConnectionStatus {
  NotConnected = 'Not Connected',
  AccessRequested = 'Access Requested',
  Invited = 'Invited',
  Connected = 'Connected',
  AccessRevoked = 'Access Revoked',
}

// Vendor with enriched access status
export interface VendorWithAccessStatus extends SiteSettings {
  connectionStatus: VendorConnectionStatus;
  canRequestAccess: boolean;
  accessRequestId?: string;
  rateLimitStatus?: AccessRequestRateLimitStatus;
}
